export default "__VITE_ASSET__yC5Pvho5__"